module.exports = __webpack_public_path__ + "img/banner.782e7a30.png";